<template>
  <div>
    <div>
      <b-alert
        show
        variant="dark"
        class="margin-bottom font12px"
        v-if="this.DrugNonDrugLoadSTD"
      >
        <h6>Rx Order</h6>
        <b-row class="margin-bottom">
          <b-col lg="6">
            <b-alert
              show
              v-for="(item, index) in this.Pag1Data"
              v-bind:key="item.id"
              class="margin-bottom2px"
              :class="
                setItemBgColor(
                  item.datas.icode,
                  item.datas.drugNondugFullName,
                  item.datas.income
                ).durgitems_color
              "
              :title="
                setItemBgColor(
                  item.datas.icode,
                  item.datas.drugNondugFullName,
                  item.datas.income
                ).durgitems_title
              "
            >
              <div>
                <b-row>
                  <b-col>
                    <div class="pj_clearfix">
                      <div class="float-left">
                        {{ index + 1 }}.
                        <div
                          :title="
                            'ห้องยาบันทึกจ่ายยาแล้ว \n' +
                              pjFunctionsFc.NulltoStr(
                                item.datas.pay_staff_name
                              ) +
                              ' \nLog. ' +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.pay_datetime
                              )
                          "
                          class="float-left"
                          v-if="item.datas.pay_staff_status == 'Y'"
                        >
                          <v-icon
                            name="check-circle"
                            class="icon-pay-check-read"
                          ></v-icon>
                        </div>
                        {{ item.datas.drugNondugFullName }}
                      </div>
                      <div class="float-right">
                        <strong
                          class="font-color-primary"
                          v-if="item.datas.paidst == '02' || !item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                        <strong
                          class="font-color-danger"
                          v-if="item.datas.paidst != '02' && item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                      </div>
                    </div>
                    <div
                      class="pj_clearfix"
                      v-if="
                        item.datas.drug_usage_full &&
                          (item.datas.drug_usage_ename == null ||
                            item.datas.drug_usage_ename == '' ||
                            item.datas.drug_usage_ename == 'null')
                      "
                    >
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_full }}
                    </div>
                    <div class="pj_clearfix" v-if="item.datas.drug_usage_ename">
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_ename }}
                    </div>
                    <div
                      class="pj_clearfix log-style"
                      v-if="item.datas.doctor_name"
                    >
                      {{
                        "&nbsp;&nbsp; Order." +
                          pjFunctionsFc.NulltoStr(item.datas.doctor_name) +
                          " | " +
                          thaiDatetimeFc.ThaiDateTime(
                            item.datas.rxdate + " " + item.datas.rxtime
                          )
                      }}
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <v-icon
                      name="plus-square"
                      class="icon-custom1 cursor-pointer"
                      v-bind:class="{
                        'icon-success': item.datas.items_note_text
                      }"
                      v-b-toggle="'Tg' + item.datas.hos_guid"
                    ></v-icon>
                  </b-col>
                </b-row>
                <b-collapse
                  :id="'Tg' + item.datas.hos_guid"
                  :visible="item.datas.items_note_text && true"
                >
                  <b-form :id="'rxForm' + item.datas.hos_guid">
                    <b-row>
                      <b-col>
                        <input
                          type="hidden"
                          :value="item.datas.icode"
                          :id="'icodeNote' + item.datas.hos_guid"
                        />
                        <b-form-textarea
                          :id="'rxNoteta' + item.datas.hos_guid"
                          size="sm"
                          max-rows="5"
                          :value="
                            pjFunctionsFc.NulltoStr(item.datas.items_note_text)
                          "
                        >
                        </b-form-textarea>
                        <div
                          class="pj_clearfix log-style"
                          v-if="item.datas.items_note_user"
                        >
                          {{
                            "&nbsp;&nbsp; Log." +
                              pjFunctionsFc.NulltoStr(
                                item.datas.items_note_user
                              ) +
                              " | " +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.items_note_datetime
                              )
                          }}
                        </div>
                      </b-col>
                      <b-col cols="1">
                        <b-button
                          @click="rxNoteSubmit(item.datas.hos_guid)"
                          variant="link"
                          style="padding:0px;"
                        >
                          <v-icon
                            name="save"
                            class="icon-custom1 icon-primary cursor-pointer"
                            style="margin-top:100%;"
                          ></v-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-collapse>
              </div>
            </b-alert>
          </b-col>
          <b-col lg="6">
            <b-alert
              show
              v-for="(item, index) in this.Pag2Data"
              v-bind:key="item.id"
              class="margin-bottom2px"
              :class="
                setItemBgColor(
                  item.datas.icode,
                  item.datas.drugNondugFullName,
                  item.datas.income
                ).durgitems_color
              "
              :title="
                setItemBgColor(
                  item.datas.icode,
                  item.datas.drugNondugFullName,
                  item.datas.income
                ).durgitems_title
              "
            >
              <div>
                <b-row>
                  <b-col>
                    <div class="pj_clearfix">
                      <div class="float-left">
                        {{ index + Pag2Start + 1 }}.
                        <div
                          :title="
                            'ห้องยาบันทึกจ่ายยาแล้ว \n' +
                              pjFunctionsFc.NulltoStr(
                                item.datas.pay_staff_name
                              ) +
                              ' \nLog. ' +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.pay_datetime
                              )
                          "
                          class="float-left"
                          v-if="item.datas.pay_staff_status == 'Y'"
                        >
                          <v-icon
                            name="check-circle"
                            class="icon-pay-check-read"
                          ></v-icon>
                        </div>
                        {{ item.datas.drugNondugFullName }}
                      </div>
                      <div class="float-right">
                        <strong
                          class="font-color-primary"
                          v-if="item.datas.paidst == '02' || !item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                        <strong
                          class="font-color-danger"
                          v-if="item.datas.paidst != '02' && item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                      </div>
                    </div>
                    <div
                      class="pj_clearfix"
                      v-if="
                        item.datas.drug_usage_full &&
                          (item.datas.drug_usage_ename == null ||
                            item.datas.drug_usage_ename == '' ||
                            item.datas.drug_usage_ename == 'null')
                      "
                    >
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_full }}
                    </div>
                    <div class="pj_clearfix" v-if="item.datas.drug_usage_ename">
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_ename }}
                    </div>
                    <div
                      class="pj_clearfix log-style"
                      v-if="item.datas.doctor_name"
                    >
                      {{
                        "&nbsp;&nbsp; Order." +
                          pjFunctionsFc.NulltoStr(item.datas.doctor_name) +
                          " | " +
                          thaiDatetimeFc.ThaiDateTime(
                            item.datas.rxdate + " " + item.datas.rxtime
                          )
                      }}
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <v-icon
                      name="plus-square"
                      class="icon-custom1 cursor-pointer"
                      v-bind:class="{
                        'icon-success': item.datas.items_note_text
                      }"
                      v-b-toggle="'Tg' + item.datas.hos_guid"
                    ></v-icon>
                  </b-col>
                </b-row>
                <b-collapse
                  :id="'Tg' + item.datas.hos_guid"
                  :visible="item.datas.items_note_text && true"
                >
                  <b-form :id="'rxForm' + item.datas.hos_guid">
                    <b-row>
                      <b-col>
                        <input
                          type="hidden"
                          :value="item.datas.icode"
                          :id="'icodeNote' + item.datas.hos_guid"
                        />
                        <b-form-textarea
                          :id="'rxNoteta' + item.datas.hos_guid"
                          size="sm"
                          max-rows="5"
                          :value="
                            pjFunctionsFc.NulltoStr(item.datas.items_note_text)
                          "
                        >
                        </b-form-textarea>
                        <div
                          class="pj_clearfix log-style"
                          v-if="item.datas.items_note_user"
                        >
                          {{
                            "&nbsp;&nbsp; Log." +
                              pjFunctionsFc.NulltoStr(
                                item.datas.items_note_user
                              ) +
                              " | " +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.items_note_datetime
                              )
                          }}
                        </div>
                      </b-col>
                      <b-col cols="1">
                        <b-button
                          @click="rxNoteSubmit(item.datas.hos_guid)"
                          variant="link"
                          style="padding:0px;"
                        >
                          <v-icon
                            name="save"
                            class="icon-custom1 icon-primary cursor-pointer"
                            style="margin-top:100%;"
                          ></v-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-collapse>
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <b-row v-if="this.DrugNonDrugPayLoadSTD">
          <b-col lg="3">
            <b-alert
              show
              variant="success"
              class="font12px font-bold text-align-right"
            >
              <div>รวมเงิน : {{ this.SumPrice.total_price }}฿</div>
            </b-alert>
          </b-col>
          <b-col lg="3">
            <b-alert
              show
              variant="primary"
              class="font12px font-bold text-align-right"
            >
              <div>ลูกหนี : {{ this.SumPrice.privilege_paid }}฿</div>
            </b-alert>
          </b-col>
          <b-col lg="3">
            <b-alert
              show
              variant="warning"
              class="font12px font-bold text-align-right"
            >
              <div>ชำระเงิน : {{ this.SumPrice.cash_paid }}฿</div>
            </b-alert>
          </b-col>
          <b-col lg="3">
            <b-alert
              show
              variant="danger"
              class="font12px font-bold text-align-right"
            >
              <b-badge
                href="#"
                @click="
                  SubmitPayment(
                    'AddPatment',
                    'ยืนยันการส่งชำระเงิน (Payment). !'
                  )
                "
                variant="danger"
                class="font14px"
                title="Payment !"
                v-if="this.SumPrice.nopay_total_price > 0 && !this.PaySTD"
              >
                Payment :
                {{ this.SumPrice.nopay_total_price }}฿
              </b-badge>
              <b-badge
                href="#"
                @click="
                  SubmitPayment(
                    'AddPatment',
                    'ยืนยันการส่งชำระเงิน (Payment). !'
                  )
                "
                variant="warning"
                class="font14px"
                :title="PaySTDTxt"
                v-if="this.SumPrice.nopay_total_price > 0 && this.PaySTD"
              >
                Payment :
                {{ this.SumPrice.nopay_total_price }}฿
              </b-badge>
              <div v-if="this.SumPrice.nopay_total_price <= 0">
                Payment : {{ this.SumPrice.nopay_total_price }}฿
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-alert>
    </div>

    <!-- CSS animation example -->
    <notifications
      group="drug-nonedrug-foo-css"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <!-- Custom template example -->
    <notifications
      group="drug-nonedrug-custom-save"
      :speed="500"
      animation-name="v-fade-left"
      position="bottom right"
    >
      <template slot="body" slot-scope="props">
        <div class="drug-nonedrug-custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="transition-timing-function: ease; transition-delay: 0s; transition-property: all;"
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientDrugNoneDrug from "@/models/patientEMRs/PatientDrugNoneDrug";
import Notifications from "vue-notification";
import DrugNarcotic from "@/models/patientEMRs/DrugNarcotic";

Vue.use(feather, "v-icon");
Vue.use(Notifications);

@Component({
  data() {
    return {
      itemBgColor: "durgitems-bgcolor1",
      vnStart: "",
      PaySTDTxt: "",
      PaySTD: false,
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      DrugNoneData: null,
      apiCk: 0,
      Pag1Limit: 0,
      Pag2Start: 0,
      Pag1Data: null,
      Pag2Data: null,
      showCollapse: true,
      ptHN: "",
      ptVN: "",
      DataCh: "",
      id: 0,
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        },
        leave: {
          opacity: 0,
          height: 0
        }
      },
      SumPrice: {
        total_price: 0,
        privilege_paid: 0,
        cash_paid: 0,
        nopay_total_price: 0
      },
      DrugNonDrugLoadSTD: false,
      DrugNonDrugPayLoadSTD: false
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientDrugNoneDrug
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
  },
  watch: {
    ptHN: function() {
      // this.setDrugNoneDrugData(this.ptVN, this.ptHN);
      // this.setDrugNoneDrugPriceData(this.ptVN, this.ptHN);
    },
    ptVN: function() {
      this.setDrugNoneDrugData(this.ptVN, this.ptHN);
      this.setDrugNoneDrugPriceData(this.ptVN, this.ptHN);
    },
    DataCh: function() {
      this.getDrugNoneDrugData(this.ptVN, this.ptHN);
      this.getDrugNoneDrugPriceData(this.ptVN, this.ptHN);
    },
    MyVn: function() {
      if (this.MyVn != "" && this.MyVn != null) {
        this.vnChang;
      }
    }
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
    }
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    setItemBgColor(icode, name, income) {
      let durgitems_color = "durgitems-bgcolor1";
      let durgitems_title = "";

      if (income == "17") {
        durgitems_color = "durgitems-bgcolor2";
        durgitems_title =
          "ค่ายานอกบัญชียาหลักแห่งชาติ(ต้องมีใบรับรองจึงเบิกได้)";
      }

      if (name.search("consult") == 0 || name.search("Consult") == 0) {
        durgitems_color = "durgitems-bgcolor4";
        durgitems_title = "รายการ Consult";
      }

      let ScrObj = DrugNarcotic.query()
        .where(record => record.icode == icode)
        .where(record => record.item_satus == "Y")
        .get();

      if (ScrObj.length > 0) {
        durgitems_color = "durgitems-bgcolor3";
        durgitems_title =
          "ยาเสพติดให้โทษ (ประเภท " + ScrObj[0].narcotic_type + ")";
      }

      let datas = {
        durgitems_color: durgitems_color,
        durgitems_title: durgitems_title
      };

      return datas;
    },
    SubmitPayment(act, txt) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm(txt, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            if (act == "AddPatment") {
              let datas = {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                vn: this.ptVN,
                hn: this.ptHN,
                privilege_paid: this.SumPrice.privilege_paid,
                payments_sum: this.SumPrice.nopay_total_price,
                cash_paid: this.SumPrice.cash_paid,
                total_price: this.SumPrice.total_price
              };

              let ScrObj = this;
              this.axios
                .post(
                  this.$store.get("systems@UrlApi") + "PaymentTranAdd",
                  datas
                )
                .then(function(response) {
                  ScrObj.output = response.data;
                  if (ScrObj.output.status === true) {
                    ScrObj.show(
                      "notifi-main-top-right",
                      "success",
                      "Delete Data Success",
                      "การบันทึนเสร็จสมบูรณ์ ^_^ <br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );
                  } else {
                    ScrObj.show(
                      "notifi-main-top-right",
                      "warn",
                      "Save Data Error",
                      "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                        "<br>ErrorMessage : " +
                        ScrObj.output.ErrorMessage +
                        "<br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );
                  }
                })
                .catch(function(error) {
                  ScrObj.output = error;

                  ScrObj.show(
                    "notifi-main-top-right",
                    "error",
                    "Save Data Error",
                    "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                      "<br>ErrorMessage : " +
                      ScrObj.output +
                      "<br>Date : " +
                      ScrObj.thaiDatetimeFc.ThaiDateTime(
                        ScrObj.thaiDatetimeFc.DateTimeNow()
                      )
                  );

                  console.log("PaymentTranAdd : " + ScrObj.output);
                })
                .finally(function() {
                  ScrObj.setDrugNoneDrugPriceData(ScrObj.ptVN, ScrObj.ptHN);
                });
            }
          }
        })
        .catch(err => {
          // An error occurred
        });
    },

    rxNoteSubmit(rxNoteId) {
      let rxNoteForm = document.getElementById("rxForm" + rxNoteId);
      let rxNoteText = rxNoteForm["rxNoteta" + rxNoteId].value;
      let rxIcode = rxNoteForm["icodeNote" + rxNoteId].value;

      if (rxIcode != "" && rxNoteId != "") {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DrugNonDrugNoteAdd", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: ScrObj.ptHN,
            vn: ScrObj.ptVN,
            hos_guid: rxNoteId,
            icode: rxIcode,
            rx_note_text: rxNoteText
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              ScrObj.show(
                "drug-nonedrug-foo-css",
                "success",
                "Save Data Success",
                "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );
            } else {
              ScrObj.show(
                "drug-nonedrug-foo-css",
                "warn",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output.ErrorMessage +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
            }
          })
          .catch(function(error) {
            ScrObj.output = error;

            ScrObj.show(
              "drug-nonedrug-foo-css",
              "error",
              "Save Data Error",
              "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );

            console.log("DrugNonDrugNoteAdd : " + ScrObj.output);
          })
          .finally(function() {
            // ScrObj.setDrugNoneDrugData(ScrObj.ptVN, ScrObj.ptHN);
            ScrObj.setDrugNoneDrugData(ScrObj.ptVN, ScrObj.ptHN);
          });
      }
    },
    setDrugNoneDrugData: function(vn, hn) {
      if (vn != "" && vn != null) {
        this.DrugNonDrugLoadSTD = false;

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DrugNonDrugData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientDrugNoneDrug.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.hos_guid,
                  hn: val.hn,
                  vn: val.vn,
                  an: val.an,
                  datas: val
                });
              }

              PatientDrugNoneDrug.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientDrugNoneDrug.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("DrugNonDrugData : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.DataCh = "DrugNonDrugData" + vn;
            ScrObj.DrugNonDrugLoadSTD = true;
            ScrObj.getDrugNoneDrugData(vn, hn);
          });
      }
    },
    getDrugNoneDrugData(vn, hn) {
      let ScrObj = PatientDrugNoneDrug.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      this.Pag1Limit = Math.ceil(ScrObj.length / 2);
      this.Pag2Start = Math.ceil(ScrObj.length / 2);

      if (ScrObj.length > 0) {
        let P1 = [];
        let P2 = [];

        for (let i = 0; i < this.Pag1Limit; i++) {
          P1.push(ScrObj[i]);
        }

        for (let i2 = this.Pag2Start; i2 < ScrObj.length; i2++) {
          P2.push(ScrObj[i2]);
        }

        this.Pag1Data = P1;
        this.Pag2Data = P2;

        this.DrugNoneData = ScrObj[0];
        this.apiCk = this.apiCk + 1;
      } else {
        this.DrugNoneData = null;
        this.Pag1Data = null;
        this.Pag2Data = null;
        this.apiCk = this.apiCk + 1;
      }
    },
    setDrugNoneDrugPriceData: function(vn, hn) {
      if (vn != "" && vn != null) {
        this.DrugNonDrugPayLoadSTD = false;

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "PaymentTranData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn,
            payStatus: "Y"
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              if (ScrObj.output.result.length > 0) {
                ScrObj.PaySTD = true;
                ScrObj.PaySTDTxt =
                  "Wait Payment \nA : " +
                  ScrObj.output.result[0].payments_tran_user +
                  " \nU : " +
                  ScrObj.output.result[0].edit_payments_tran_user;
              } else {
                ScrObj.PaySTD = false;
                ScrObj.PaySTDTxt = "";
              }
            } else {
              ScrObj.PaySTD = false;
              ScrObj.PaySTDTxt = "";
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("PaymentTranData : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.getDrugNoneDrugPriceData(vn, hn);
            ScrObj.DrugNonDrugPayLoadSTD = true;
          });
      }
    },
    getDrugNoneDrugPriceData(vn, hn) {
      let ScrObj = PatientDrugNoneDrug.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      let total_price = 0;
      let privilege_paid = 0;
      let cash_paid = 0;
      let nopay_total_price = 0;

      if (ScrObj.length > 0) {
        for (let i = 0; i < ScrObj.length; i++) {
          if (ScrObj[i].datas.paidst == "02") {
            privilege_paid =
              parseFloat(privilege_paid) +
              parseFloat(ScrObj[i].datas.sum_price + 0);
          } else {
            cash_paid =
              parseFloat(cash_paid) + parseFloat(ScrObj[i].datas.sum_price + 0);
          }

          if (
            ScrObj[i].datas.finance_number == "" ||
            ScrObj[i].datas.finance_number == "null" ||
            ScrObj[i].datas.finance_number == null
          ) {
            nopay_total_price =
              parseFloat(nopay_total_price) +
              parseFloat(ScrObj[i].datas.sum_price + 0);
          }

          total_price =
            parseFloat(total_price) + parseFloat(ScrObj[i].datas.sum_price + 0);
        }

        this.SumPrice = {
          total_price: total_price.toFixed(2),
          privilege_paid: privilege_paid.toFixed(2),
          cash_paid: cash_paid.toFixed(2),
          nopay_total_price: nopay_total_price.toFixed(2)
        };
      } else {
        this.SumPrice = {
          total_price: 0,
          privilege_paid: 0,
          cash_paid: 0,
          nopay_total_price: 0
        };
      }
    },
    delDrugNoneDrugData(vn) {
      PatientDrugNoneDrug.delete({
        where(record) {
          return record.vn == vn;
        }
      });
    }
  }
})
export default class EmrDrugNoneDrugOPD extends Vue {}
</script>

<style lang="scss">
.icon-pay-check-read {
  margin-top: -2px;
  width: 14px;
  color: red !important;
}
</style>

